export default __webpack_public_path__ + "pgnv-assets/176985210b5e35a409df99eb7042cca8.png";